import Hero from "./components/hero/Hero";
import Navbar from "./components/navbar/Navbar";
import heroImage from './assets/heroImage.png'
import Customer from "./components/esteemedCustomer/Customer";
import AboutUs from "./components/aboutUs/AboutUs";
// import Team from "./components/team/Team";
import Services from "./components/services/Services";
import CustomerReview from "./components/customerReview/CustomerReview";
import Numbers from "./components/numbers/Numbers";
import Contact from "./components/contacts/Contact";
import Footer from "./components/footer/Footer";


function App() {
  return (
    <div className="App">
      <div style={{
          backgroundImage: `linear-gradient(98.09deg, rgba(0, 0, 0, 0.7) 9.36%, rgba(255, 255, 255, 0) 100.33%), url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          }} className="h-[554px] md:h-[696px]">
              <Navbar />
              <Hero />
      </div>
          <Customer />
          <AboutUs  />
          {/* <div className="md:hidden">
          <Team />
          </div> */}
          <Services />
          <CustomerReview />
          <Numbers />
          <Contact />
          <Footer />
    </div>
  );
}

export default App;
